import React from "react";
import { BiEdit, BiTrash } from "react-icons/bi";
import { AiOutlineShareAlt } from "react-icons/ai";
import { Link } from "react-router-dom";
import { truncateText } from "../../utils/Truncate";
import { useTranslations } from "../../../translations";

const Texts = ({ currentItems, itemOffset, handleDelete, isTeacher, onDistribute }) => {
  const { t } = useTranslations();
  if (currentItems.length <= 0) {
    return (
      <tr>
        <td colSpan={6} className="text-center py-5 text-muted italic">
          {t("noTextsYet")}
        </td>
      </tr>
    );
  }

  return currentItems.map((text, index) => {
    return (
      <tr key={text.id} className="align-middle">
        <td className="text-center fw-bold color-plum opacity-50">{index + 1 + itemOffset}</td>
        <td>
          <div className="fw-bold color-plum mb-0" style={{ fontSize: '1rem' }}>{truncateText(text.text, 60)}</div>
        </td>
        <td className="text-center">
          <span className="badge rounded-pill px-3 py-2" style={{ background: 'var(--pastel-pink)', color: 'var(--pink-bright)', fontWeight: '700' }}>
            {text.numberOfQuestions} {t("questions")}
          </span>
        </td>
        <td>
          <div className="d-flex justify-content-center gap-2">
            {isTeacher && (
              <button
                className="btn-action-edit"
                style={{ color: "#eb2178", borderColor: "#f3c6db" }}
                onClick={() => onDistribute(text)}
                title={t("distributeTooltip")}
              >
                <AiOutlineShareAlt size={20} />
              </button>
            )}
            <Link
              className="btn-action-edit"
              to={`/actions/texts/edit/${text.id}`}
              title={t("edit")}
            >
              <BiEdit size={20} />
            </Link>
            <button
              className="btn-action-delete"
              onClick={() => handleDelete(text.id)}
              title={t("delete")}
            >
              <BiTrash size={20} />
            </button>
          </div>
        </td>
      </tr>
    );
  });
};

export default Texts;
